import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        languageWrapper: {
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('xs')]: {
                justifyContent: 'center',
            },
        },
        language: {
            borderRadius: 50,
            color: theme.palette.text.primary,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            textAlign: 'left',
            marginLeft: theme.spacing(1),
            '&:hover': {
                backgroundColor: theme.palette.background.default,
            },
            [theme.breakpoints.down('xs')]: {
                marginLeft: 0,
            },
        },
    };
});
